import React from 'react';

import Button from 'Components/Globals/Elements/Button/loadable';
import ItemModal from '../ItemModal';
import useContent from 'Hooks/useContent';

import strings from './strings';

const WalletTransactionModal = ({ onClose, data }) => {
	const { formatMessage } = useContent();

	return (
		<>
			<div className={`sm mb-24`}>
				<ItemModal
					status={data?.attributes?.settlement?.status}
					amount={data?.attributes?.amount}
					traceId={data?.attributes?.trace_id}
					confirmedAt={data?.attributes?.confirmed_at}
					payedAt={data?.attributes?.settlement?.payed_at}
					settlementId={data?.attributes?.settlement?.trace_id}
					isSettlement={data?.attributes?.settlement?.status === 'done'}
				/>
			</div>

			<Button
				label={formatMessage(strings.buttonLabel)}
				onClick={onClose}
				variant={'outline'}
				size={'lg'}
				block={true}
				color={'neutral-gray'}
				className='mt-24'
			/>
		</>
	);
};

export default WalletTransactionModal;
